import { Component } from "@angular/core";
import { AutoUnsubscribe } from "../../shared/decorators/auto-unsubscribe.decorator";
import { FaxQueueComponent } from "../base/fax-queue.component";
import { FaxQueue } from "projects/um/src/assets/constants";

@Component({
    selector: 'app-team-queue-faxes',
    templateUrl: './team-queue-faxes.component.html',
    styleUrls: ['./team-queue-faxes.component.scss'],
    standalone: false
})
@AutoUnsubscribe
export class TeamQueueFaxesComponent extends FaxQueueComponent {
    override faxView: FaxQueue = FaxQueue.TEAM_FAXES;
}